var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fdfdfd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.083 1.667)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.529,15.644V13.1a1.182,1.182,0,0,1,1.186-1.178h2.4a1.191,1.191,0,0,1,.839.345,1.173,1.173,0,0,1,.347.833v2.548a1.011,1.011,0,0,0,.3.722,1.026,1.026,0,0,0,.725.3h1.634a2.883,2.883,0,0,0,2.036-.833,2.841,2.841,0,0,0,.844-2.019V6.556a2.061,2.061,0,0,0-.746-1.585L9.528.563A2.581,2.581,0,0,0,6.238.622L.806,4.971A2.062,2.062,0,0,0,0,6.556v7.252a2.87,2.87,0,0,0,2.88,2.859h1.6a1.026,1.026,0,0,0,1.03-1.015Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1565ea7f255e300eee79e18ea4edc0a4.svg";
export { ForwardRef as ReactComponent };